module.exports = __webpack_public_path__ + "image/header-bg1.png";